import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Sidebar from '.././components/sidebar'
import Config from './config'
import '../styles/main.scss'
import '../styles/fonts/font-awesome/css/font-awesome.min.css'
import AdSense from './adsense'

const DefaultLayout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            author
            company
            description
            social {
              twitter
              instagram
              facebook
              linkedin
              github
              email
            }
          }
        }
      }
    `}
    render={(data) => (
      <>
        <nav className="nav">
          <div className="container">
            <a href={Config.URL} className="navbar-brand">
              <img
                src={`${Config.URL}/img/icon/fun_logo.png`}
                alt="PlayGoKids"
              />
            </a>
            <div>
              <ul className="navbar-nav">
                <li className="nav-item">
                  <a className="nav-link" href={`${Config.URL}#download`}>
                    Download
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={`${Config.URL}#contact`}>
                    Contact
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href={`${Config.BLOG_URL}`}>
                    Tech
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="wrapper">
          <Helmet>
            <link
              href="https://fonts.googleapis.com/css?family=Lato|PT+Serif&display=swap"
              rel="stylesheet"
            />
          </Helmet>
          <Sidebar siteMetadata={data.site.siteMetadata} />
          {children}
          <div className="adbar">
            <AdSense client="ca-pub-1581901612485668" slot="9784632318" />
          </div>
        </div>
      </>
    )}
  />
)

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default DefaultLayout
